const tagcloudsWithPlaceholders = ({adsListTypesConfig, tagclouds, initialSearch, i18n}) => {
  const {categoryId, vehicles = []} = initialSearch
  const type = adsListTypesConfig?.[categoryId]?.[i18n.culture] || ''
  const [firstVehicle = {}] = vehicles
  const {make: makeName, model = {}} = firstVehicle
  const {name: modelName} = model

  return tagclouds.map(tagcloud => {
    return {
      ...tagcloud,
      placeholders: {
        makeName: makeName?.toUpperCase() || i18n.t('COMMON.PLURALS.MODEL', 0).toLowerCase(),
        modelName,
        type
      }
    }
  })
}
export default tagcloudsWithPlaceholders
